"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTargetWindow = void 0;
// NOTE: Type TargetWindow is an auto-generated type.
// Run node ./tools/generateTargetWindow.js to generate it.
/**
 * @internal Export for test only
 * Try get window from the given node or range
 * @param node Source node to get window from
 */
function getTargetWindow(node) {
    var document = node &&
        (node.ownerDocument ||
            (Object.prototype.toString.apply(node) == '[object HTMLDocument]'
                ? node
                : null));
    // If document exists but document.defaultView doesn't exist, it is a detached object, just use current window instead
    var targetWindow = document && (document.defaultView || window);
    return targetWindow;
}
exports.getTargetWindow = getTargetWindow;
/**
 * Check if the given object is instance of the target type
 * @param obj Object to check
 * @param typeName Target type name
 */
function safeInstanceOf(obj, typeName) {
    var _a;
    if (typeName == 'Range') {
        return (Object.prototype.toString.apply(obj) == '[object Range]' &&
            !!((_a = obj) === null || _a === void 0 ? void 0 : _a.commonAncestorContainer));
    }
    var targetWindow = getTargetWindow(obj);
    var targetType = targetWindow && targetWindow[typeName];
    var mainWindow = window;
    var mainWindowType = mainWindow && mainWindow[typeName];
    return ((mainWindowType && obj instanceof mainWindowType) ||
        (targetType && obj instanceof targetType));
}
exports.default = safeInstanceOf;
//# sourceMappingURL=safeInstanceOf.js.map